/**
 * Resume marker for "social sign-in started from inside checkout".
 *
 * Social auth is redirect-based (full-page navigation), which destroys all
 * React state. After the OAuth round-trip the BookingDetailsModal is closed.
 * This tiny sessionStorage-backed marker lets a page-level bridge detect the
 * return and re-open checkout for the same tee time. SoC: it knows nothing
 * about drafts, only which tee time to resume and when it was requested.
 */
export const CHECKOUT_RESUME_TEETIME_KEY = 'tee-time.checkout.resumeTeetimeUID';
export const CHECKOUT_RESUME_TIMESTAMP_KEY = 'tee-time.checkout.resumeTimestamp';
/** Maximum age of a resume marker before it is considered stale (10 minutes). */
export const CHECKOUT_RESUME_MAX_AGE_MS = 10 * 60 * 1000;
/**
 * Record that checkout should resume for the given tee time after the
 * social-auth redirect returns.
 */
export function markCheckoutResume(teetimeUID) {
    if (typeof window === 'undefined')
        return;
    try {
        sessionStorage.setItem(CHECKOUT_RESUME_TEETIME_KEY, teetimeUID);
        sessionStorage.setItem(CHECKOUT_RESUME_TIMESTAMP_KEY, Date.now().toString());
    }
    catch {
        /* ignore storage errors */
    }
}
/**
 * Return the tee time UID to resume if a marker exists and is within the max
 * age. Stale, malformed, or missing markers are cleared and null is returned.
 */
export function readCheckoutResume() {
    if (typeof window === 'undefined')
        return null;
    try {
        const teetimeUID = sessionStorage.getItem(CHECKOUT_RESUME_TEETIME_KEY);
        if (!teetimeUID) {
            return null;
        }
        const timestampRaw = sessionStorage.getItem(CHECKOUT_RESUME_TIMESTAMP_KEY);
        const storedAt = timestampRaw === null ? Number.NaN : Number.parseInt(timestampRaw, 10);
        if (Number.isNaN(storedAt)) {
            clearCheckoutResume();
            return null;
        }
        if (Date.now() - storedAt > CHECKOUT_RESUME_MAX_AGE_MS) {
            clearCheckoutResume();
            return null;
        }
        return teetimeUID;
    }
    catch {
        return null;
    }
}
/** Remove any stored checkout resume marker. */
export function clearCheckoutResume() {
    if (typeof window === 'undefined')
        return;
    try {
        sessionStorage.removeItem(CHECKOUT_RESUME_TEETIME_KEY);
        sessionStorage.removeItem(CHECKOUT_RESUME_TIMESTAMP_KEY);
    }
    catch {
        /* ignore storage errors */
    }
}
//# sourceMappingURL=checkoutResume.js.map